import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type PostWeather, updatePost } from "@/adapters/api";
import type { Post } from "@/features/feed/types.ts";
import { updatePostCaches } from "@/features/feed/utils/cache.ts";
import { toPost } from "@/features/feed/utils/map.ts";

export interface UpdatePostFields {
	title: string;
	body: string;
	internal: boolean;
	weatherCondition?: PostWeather;
	stageId?: string;
}

export function useUpdatePost(postId: string) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (fields: UpdatePostFields): Promise<Post> =>
			toPost(await updatePost(postId, fields)),
		onSuccess: (post) => {
			updatePostCaches(queryClient, postId, () => post);
		},
	});
}
